module.exports = __webpack_public_path__ + "static/media/theweathercompany.5ac55d36.jpg";